export const INVALID_NAME_MSG =
  "One of the names you're updating doesn't have a length between 1 and 255 characters, fix that and try again.";
